import has from 'lodash.has';
export default {
    computed: {
        canEdit () {
            if (has(this.$route.params, 'warehouseVerifyPermissions')) {
                return this.$route.params.warehouseVerifyPermissions.editable;
            }
            return false;
        },
        canAccept () {
            if (has(this.$route.params, 'warehouseVerifyPermissions')) {
                return this.$route.params.warehouseVerifyPermissions.acceptable;
            }
            return false;
        },
        canEditPublishedWarehouse () {
            if (has(this.$route.params, 'canEditPublishedWarehouse')) {
                return this.$route.params.canEditPublishedWarehouse;
            }
            return false;
        }
    }
};
